import { render, staticRenderFns } from "./ImgTextOptions.vue?vue&type=template&id=73b486ac&scoped=true"
import script from "./ImgTextOptions.vue?vue&type=script&lang=js"
export * from "./ImgTextOptions.vue?vue&type=script&lang=js"
import style0 from "./ImgTextOptions.vue?vue&type=style&index=0&id=73b486ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b486ac",
  null
  
)

export default component.exports